export const locale = {
    lang: 'en',
    data: {
        NAVBAR_STYLE_2_TITLE: 'Sales Module',
    },
};
